import React from 'react';
import './Stepper.scss';
import { FaCheck } from 'react-icons/fa';

const Stepper = ({ steps = [], currentStep = 0 }) => {
	return (
		<div className="container py-4">
			<div className="stepper">
				{steps.map((step, index) => {
					const isCompleted = index < currentStep;
					const isActive = index === currentStep;

					return (
						<React.Fragment key={index}>
							<div className="step">
								<div
									className={`step-circle 
                    ${isCompleted ? 'completed' : ''} 
                    ${isActive ? 'active' : ''}`}
								>
									{isCompleted ? <FaCheck size={12} /> : index + 1}
								</div>

								<p className={`step-label ${isActive ? 'active-label' : ''}`}>{step.label}</p>
							</div>

							{index < steps.length - 1 && (
								<div className={`step-line ${index < currentStep ? 'active' : ''}`} />
							)}
						</React.Fragment>
					);
				})}
			</div>
		</div>
	);
};

export default Stepper;
